import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import { getFullMediaUrl } from "../utils/helpers";

export default function Blogdetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const news = location.state?.news || null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <>
      <div id="layout-wrapper">
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-soft-secondary me-3"
                        onClick={() => navigate(-1)}
                        title="Go Back"
                      >
                        <i className="mdi mdi-arrow-left fs-5" />
                      </button>
                      <h2 className="fw-700 mb-sm-0">News Details</h2>
                    </div>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-12 col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="pt-3">
                        <div className="row justify-content-center">
                          <div className="col-xl-11">
                            <div>
                              <div className="text-center">
                                {/* Category & Sentiment Badges */}
                                <div className="mb-3 d-flex justify-content-center gap-2 flex-wrap">
                                  {news?.category && (
                                    <span className="badge bg-light font-size-12 text-dark text-capitalize">
                                      <i className="bx bx-purchase-tag-alt align-middle text-muted me-1" />
                                      {news.category}
                                    </span>
                                  )}
                                  {news?.sentiment && (
                                    <span
                                      className={`badge text-capitalize ${news.sentiment === "positive"
                                        ? "bg-success"
                                        : news.sentiment === "negative"
                                          ? "bg-danger"
                                          : "bg-secondary"
                                        }`}
                                    >
                                      {news.sentiment}
                                    </span>
                                  )}
                                </div>

                                {/* Headline */}
                                <h4 className="mb-3">
                                  {news?.headline || "News Details"}
                                </h4>

                                {/* Meta: date & source */}
                                <p className="text-muted mb-4">
                                  <i className="mdi mdi-calendar me-1" />
                                  {news?.published_at
                                    ? formatDate(news.published_at)
                                    : ""}
                                  {news?.source && (
                                    <span className="ms-3">
                                      <i className="mdi mdi-newspaper me-1" />
                                      {news.source}
                                    </span>
                                  )}
                                </p>
                              </div>

                              {/* <hr>
                                              <div class="text-center">
                                                  <div class="row">
                                                      <div class="col-sm-4">
                                                          <div>
                                                              <p class="text-muted mb-2">Categories</p>
                                                              <h5 class="font-size-15">Project</h5>
                                                          </div>
                                                      </div>
                                                      <div class="col-sm-4">
                                                          <div class="mt-4 mt-sm-0">
                                                              <p class="text-muted mb-2">Date</p>
                                                              <h5 class="font-size-15">10 Apr, 2020</h5>
                                                          </div>
                                                      </div>
                                                      <div class="col-sm-4">
                                                          <div class="mt-4 mt-sm-0">
                                                              <p class="text-muted mb-2">Post by</p>
                                                              <h5 class="font-size-15">Gilbert Smith</h5>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                              <hr> */}
                              {/* News Image */}
                              <div className="my-5 text-center">
                                <img
                                  src={
                                    getFullMediaUrl(news?.image) ||
                                    "assets/images/small/img-2.jpg"
                                  }
                                  alt={news?.headline || "News"}
                                  className="img-thumbnail"
                                  style={{
                                    height: "400px",
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "8px"
                                  }}
                                  onError={(e) => {
                                    e.target.src = "assets/images/small/img-2.jpg";
                                  }}
                                />
                              </div>
                              <hr />
                              <div className="mt-4">
                                <div className="text-muted font-size-14">
                                  {/* Summary */}
                                  {news?.summary ? (
                                    <div
                                      dangerouslySetInnerHTML={{ __html: news.summary }}
                                      style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                                    />
                                  ) : (
                                    <p>No summary available.</p>
                                  )}

                                  {/* Original Article Link */}
                                  {news?.url && (
                                    <div className="mt-3">
                                      <a
                                        href={news.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary btn-sm"
                                      >
                                        <i className="mdi mdi-open-in-new me-1" />
                                        View Original Article
                                      </a>
                                    </div>
                                  )}

                                </div>
                                <hr />
                                <div className="mt-4">
                                  <h5 className="font-size-16 mb-3">
                                    Leave a Message
                                  </h5>
                                  <form>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label
                                            htmlFor="commentname-input"
                                            className="form-label"
                                          >
                                            Name
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="commentname-input"
                                            placeholder="Enter name"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label
                                            htmlFor="commentemail-input"
                                            className="form-label"
                                          >
                                            Email
                                          </label>
                                          <input
                                            type="email"
                                            className="form-control"
                                            id="commentemail-input"
                                            placeholder="Enter email"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mb-3">
                                      <label
                                        htmlFor="commentmessage-input"
                                        className="form-label"
                                      >
                                        Message
                                      </label>
                                      <textarea
                                        className="form-control"
                                        id="commentmessage-input"
                                        placeholder="Your message..."
                                        rows={3}
                                        defaultValue={""}
                                      />
                                    </div>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        className="btn btn-success w-sm"
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
              </div>
            </div>
            {/* container-fluid */}
          </div>
          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
